var map = {
	"./type--1-spans--multiple-lang--de.jpg": "41b6",
	"./type--1-spans--multiple-lang--en.jpg": "8305",
	"./type--1-spans--multiple-lang--es.jpg": "8238",
	"./type--1-spans--multiple-lang--fr.jpg": "9f07",
	"./type--1-spans--multiple-lang--pt.jpg": "c7d1",
	"./type--1-spans--single-lang--de.jpg": "24e7",
	"./type--1-spans--single-lang--en.jpg": "eb42",
	"./type--1-spans--single-lang--es.jpg": "5c3e",
	"./type--1-spans--single-lang--fr.jpg": "4dc5",
	"./type--1-spans--single-lang--pt.jpg": "6773",
	"./type--2-spans--multiple-lang--de.jpg": "30f5",
	"./type--2-spans--multiple-lang--en.jpg": "e6e6",
	"./type--2-spans--multiple-lang--es.jpg": "541b",
	"./type--2-spans--multiple-lang--fr.jpg": "c8a8",
	"./type--2-spans--multiple-lang--pt.jpg": "e207",
	"./type--2-spans--single-lang--de.jpg": "9709",
	"./type--2-spans--single-lang--en.jpg": "795b",
	"./type--2-spans--single-lang--es.jpg": "7c7f",
	"./type--2-spans--single-lang--fr.jpg": "379c",
	"./type--2-spans--single-lang--pt.jpg": "ea9a",
	"./type--3-spans--multiple-lang--de.jpg": "30ea",
	"./type--3-spans--multiple-lang--en.jpg": "0733",
	"./type--3-spans--multiple-lang--es.jpg": "c416",
	"./type--3-spans--multiple-lang--fr.jpg": "3e95",
	"./type--3-spans--multiple-lang--pt.jpg": "2844",
	"./type--3-spans--single-lang--de.jpg": "d9d5",
	"./type--3-spans--single-lang--en.jpg": "3ed7",
	"./type--3-spans--single-lang--es.jpg": "6332",
	"./type--3-spans--single-lang--fr.jpg": "79ec",
	"./type--3-spans--single-lang--pt.jpg": "f745",
	"./type--4-spans--multiple-lang--de.jpg": "e3a5",
	"./type--4-spans--multiple-lang--en.jpg": "2bee",
	"./type--4-spans--multiple-lang--es.jpg": "4c39",
	"./type--4-spans--multiple-lang--fr.jpg": "bb7d",
	"./type--4-spans--multiple-lang--pt.jpg": "8199",
	"./type--4-spans--single-lang--de.jpg": "20e5",
	"./type--4-spans--single-lang--en.jpg": "1837",
	"./type--4-spans--single-lang--es.jpg": "ff39",
	"./type--4-spans--single-lang--fr.jpg": "c2a8",
	"./type--4-spans--single-lang--pt.jpg": "affb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36ae";